import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/pages/LandingPage';
import ChatPage from './components/pages/ChatPage';
import TechnicalChatPage from './components/pages/TechnicalChatPage';
import ModelsPage from './components/pages/ModelsPage';
import { ChatProvider } from './context/ChatContext';
import './App.css';

function App() {
  return (
    <ChatProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/chat" element={<ChatPage />} />
            <Route path="/technical-chat" element={<TechnicalChatPage />} />
            <Route path="/models" element={<ModelsPage />} />
            <Route path="/" element={<LandingPage />} />
          </Routes>
        </div>
      </Router>
    </ChatProvider>
  );
}

export default App;
